import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { UpdateStudentDiscount } from "../../../api/StudentServices";
import { getRteStudent } from "../../../api/RteService";
import { closeModal, ToastMain, SweetAlertShow } from "../../master/Master";
import { BusRoute, BusStudentCreate, GetBus } from "../../../api/BusService";
import { imgBaseUrl } from "../../../api/api";
import usePrivateLink from "../../config/usePrivateLink";

const CourseNFeeTab = ({ data, getStudent }) => {
  const [setting, setSetting] = useState("");

  useEffect(() => {
    setSetting(JSON.parse(localStorage.getItem("setting") ?? "{}"));
  }, []);

  const [error, setError] = useState("");
  const [loading, setLoading] = useState("");
  const [modalData, setModalData] = useState(0);
  const [routes, setRoutes] = useState([]);
  const [buses, setBuses] = useState([]);
  const [searchBusId, setsearchBusId] = useState("");
  const [selectedRouteId, setSelectedRouteId] = useState("");
  const [busFees, setBusFees] = useState("");
  const [busFinalFees, setBusFinalFees] = useState("");
  const [busDiscount, setBusDiscount] = useState("");
  const [SelectedBusId, setSelectedBusId] = useState("");
  const [batchId, setBatchId] = useState(null);
  const studentId = data?.student?.id;

  const updateDicount = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await UpdateStudentDiscount(formData);

      if (response?.data?.status) {
        setError("");
        setModalData(null);
        closeModal("Courseedit");
        closeModal("editUser");
        getStudent();
        getRteStudent(data?.id);
        SweetAlertShow(
          "success",
          "Successfully",
          response?.data?.status ?? response?.data?.message
        );

        e.target.reset();
      } else {
        if (response?.data?.errors) {
          setError(response?.data?.errors);
        }
        SweetAlertShow(
          "info",
          "Warning",
          response?.data?.status ?? response?.data?.message
        );
      }
    } catch (error) {
      if (error?.response?.data?.errors) {
        setError(error?.response?.data?.errors);
      }
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const Addstudent = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await BusStudentCreate(formData); // 👈 send JSON
      if (response?.data?.status) {
        setError("");
        closeModal("addinbus");
        getStudent();
        await ToastMain.fire({
          icon: "success",
          title: response?.data?.message || "Successfully",
        });
      } else {
        if (response?.data?.errors) {
          setError(response?.data?.errors);
        }
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      if (error?.response?.data?.errors) {
        setError(error?.response?.data?.errors);
      }
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (busFees && busFinalFees) {
      const discount = busFees - busFinalFees;
      setBusDiscount(discount);
    }
  }, [busFees, busFinalFees]);

  const handleBusChange = async (busId) => {
    setLoading(true);
    setsearchBusId(busId);
    setRoutes([]);
    setSelectedRouteId("");
    setBusFees("");
    setBusFinalFees("");
    setBusDiscount("");

    try {
      const res = await BusRoute(busId);
      let routeList = res?.data?.data?.data || res?.data?.data || [];

      if (!Array.isArray(routeList)) {
        routeList = [routeList];
      }

      setRoutes(routeList);

      if (routeList.length > 0) {
        setSelectedRouteId(routeList[0].id.toString());
        setBusFees(routeList[0].route_fee || "");
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const handleRouteChange = (routeId) => {
    setSelectedRouteId(routeId);
    const selected = routes.find(
      (route) => route.id.toString() === routeId.toString()
    );
    setBusFees(selected?.route_fee || "");
  };

  const busList = async () => {
    let addUrl = `&bus_id=${SelectedBusId}&student_id=${studentId}&batch_id=${batchId}`;
    setLoading(true);
    try {
      const response = await GetBus(addUrl);
      if (response.data) {
        setBuses(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    busList();
  }, []);
  useEffect(() => {
    busList();
  }, [SelectedBusId, studentId, batchId]);

  const hasAccess = usePrivateLink();
  return (
    <div className="row">
      <div className="col-md-12">
        {data?.student?.course_and_fees?.map((item) => (
          <div
            key={item?.id}
            className="card mb-6 border border-2 border-primary rounded"
          >
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-start">
                <span className="badge bg-label-primary rounded-pill">
                  {item?.course?.title || "N/A"}:({item?.id})
                </span>
                <div className="d-flex justify-content-center">
                  <sub className="h5 pricing-currency mb-auto mt-1 text-primary">
                    ₹
                  </sub>
                  <h2 className="mb-0 text-primary">
                    {Number(item?.total_fee) +
                      Number(item?.reg_fee) +
                      Number(item?.bus_final_fees)}
                  </h2>

                  {/* <sub className="h6 pricing-duration mt-auto mb-3 fw-normal">
                    total
                  </sub> */}
                </div>
              </div>

              <ul className="list-unstyled g-2 my-6">
                <li className="mb-2 d-flex align-items-center">
                  <i className="ri-circle-fill ri-10px text-body me-2" />
                  <span>Batch: {item?.batch?.title}</span>
                </li>
                <li className="mb-2 d-flex align-items-center">
                  <i className="ri-circle-fill ri-10px text-body me-2" />
                  <span>Session: {item?.session_year?.session}</span>
                </li>
                <li className="mb-2 d-flex align-items-center">
                  {Number(item?.paid_reg_fee) == Number(item?.reg_fee) ? (
                    <i className="ri-check-fill text-success me-2" /> // ✅ tick icon green me
                  ) : (
                    <i className="ri-circle-fill ri-10px text-body me-2" /> // ⚪ normal circle
                  )}
                  <span>
                    Registration Fee: ₹{item?.reg_fee} /{" "}
                    <span className="text-success">₹{item?.paid_reg_fee}</span>
                  </span>
                </li>
                <li className="mb-2 d-flex align-items-center">
                  {Number(item.total_fee) == Number(item?.fees_paid) ? (
                    <i className="ri-check-fill text-success me-2" /> // ✅ tick icon green me
                  ) : (
                    <i className="ri-circle-fill ri-10px text-body me-2" /> // ⚪ normal circle
                  )}
                  <span>
                    Batch Fee: ₹{item?.total_fee} /{" "}
                    <span className="text-success">₹{item?.fees_paid}</span>
                  </span>
                </li>
                {item?.bus && item?.route && (
                  <li className="mb-2 d-flex align-items-center">
                    {Number(item?.bus_final_fees) ==
                    Number(item?.bus_paid_fees) ? (
                      <i className="ri-check-fill text-success me-2" /> // ✅ tick icon green me
                    ) : (
                      <i className="ri-circle-fill ri-10px text-body me-2" /> // ⚪ normal circle
                    )}
                    <span>
                      Bus Fee: ₹{item?.bus_final_fees} /{" "}
                      <span className="text-success">
                        ₹{item?.bus_paid_fees || 0}
                      </span>
                    </span>
                  </li>
                )}

                <li className="mb-2 d-flex align-items-center">
                  {Number(item?.total_fee) == Number(item?.fees_paid) ? (
                    <i className="ri-check-fill text-success me-2" /> // ✅ tick icon green me
                  ) : (
                    <i className="ri-circle-fill ri-10px text-body me-2" /> // ⚪ normal circle
                  )}
                  <span>
                    Paid Fees: ₹
                    {Number(item?.fees_paid) +
                      Number(item?.bus_paid_fees) +
                      Number(item?.paid_reg_fee)}
                  </span>
                </li>
                {item?.batch_discount && (
                  <li className="mb-2 d-flex align-items-center">
                    <i className="ri-circle-fill ri-10px text-body me-2" />
                    <span>Batch Discount: ₹{item?.batch_discount}</span>
                  </li>
                )}
                {(() => {
                  const val =
                    Number(item?.total_fee) +
                    Number(item?.bus_final_fees) +
                    Number(item?.reg_fee) -
                    (Number(item?.paid_reg_fee) +
                      Number(item?.bus_paid_fees) +
                      Number(item?.fees_paid));
                  if (val) {
                    return (
                      <li className="mb-2 d-flex align-items-center">
                        <i className="ri-alert-fill text-danger me-2" />
                        <span>
                          Remaining Fees:
                          <span className="badge bg-danger ms-2">₹{val}</span>
                        </span>
                      </li>
                    );
                  }
                })()}
              </ul>
              <hr />

              <div className="d-flex justify-content-between align-items-center mb-1">
                <span className="h6 mb-0">Fee Status</span>
                <span className="h6 mb-0">
                  {item?.fee_status === "0" ? "Pending" : "Paid"}
                </span>
              </div>

              <div className="progress mb-1 rounded" style={{ height: 6 }}>
                <div
                  className="progress-bar rounded"
                  role="progressbar"
                  style={{
                    width: `${(
                      ((Number(item?.fees_paid) +
                        Number(item?.paid_reg_fee) +
                        Number(item?.bus_paid_fees)) /
                        (Number(item?.total_fee) +
                          Number(item?.reg_fee) +
                          Number(item?.bus_final_fees))) *
                      100
                    ).toFixed(0)}%`,
                  }}
                  aria-valuenow={
                    ((Number(item?.fees_paid) +
                      Number(item?.paid_reg_fee) +
                      Number(item?.bus_paid_fees)) /
                      (Number(item?.total_fee) +
                        Number(item?.reg_fee) +
                        Number(item?.bus_final_fees))) *
                    100
                  }
                  aria-valuemin={0}
                  aria-valuemax={100}
                />
              </div>

              <small>
                Paid: ₹
                {Number(item?.fees_paid) +
                  Number(item?.paid_reg_fee) +
                  Number(item?.bus_paid_fees)}{" "}
                / ₹
                {Number(item?.total_fee) +
                  Number(item.reg_fee) +
                  Number(item?.bus_final_fees)}
              </small>

              {/* <small>
                Paid: ₹{item.fees_paid} / ₹{item.total_fee}
              </small> */}

              <div className="d-flex gap-3 mt-6">
                {hasAccess("/student/fees/deposit") && (
                  <Link
                    to={`/student/fees/deposit?id=${data?.student?.id}`}
                    className="btn btn-sm btn-primary d-flex align-items-center gap-1"
                  >
                    Pay Fees
                  </Link>
                )}
                {(hasAccess("/student/batch/transfer") ||
                  hasAccess("/student/course/discount") ||
                  hasAccess("/student/course/discount/view") ||
                  hasAccess("/student/bus/discount") ||
                  hasAccess("/student/bus/discount/view")) && (
                  <button
                    className="btn btn-sm btn-outline-primary"
                    data-bs-toggle="modal"
                    data-bs-target="#editUser"
                  >
                    View{" "}
                  </button>
                )}
                {/* <a href={`/batch_transfer?student=${data?.student?.id}`} className="btn btn-sm btn-primary">
                  &#x21C6;
                </a> */}
                {hasAccess( "/student/bus/enroll"
                  )&& setting.transport_status==='Yes' && (
                  <button
                    className="btn btn-primary"
                    data-bs-toggle="modal"
                    data-bs-target="#addinbus"
                  >
                    Admit in Bus
                  </button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="modal fade" id="editUser">
        <div className="modal-dialog modal-lg modal-edit-user">
          <div className="modal-content">
            <div className="modal-body p-3">
              <div className="d-flex justify-content-between mb-2">
                <h4 className="mb-2 text-primary">Batch Details</h4>
                <button
                  type="button"
                  className="btn-close bg-danger p-2"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>

              <div className="table-responsive">
                <table className="table table-hover align-middle text-center">
                  <thead className="table-primary">
                    <tr>
                      <th>Session</th>
                      <th>Course & Batch</th>
                      <th>Total Course Fees</th>
                      <th>Course Discount</th>
                      <th>Course Fees</th>
                      <th>Total Paid</th>
                      <th>Pending Amount</th>
                      <th>Registration Fees</th>
                      <th>Bus Fees</th>
                      <th>Total Fees</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.student?.course_and_fees?.map((fee, index) => (
                      <tr key={index}>
                        <td>{fee?.session_year?.session || "-"}</td>
                        <td>
                          {fee?.course?.title}&nbsp;
                          <span className="text-primary fw-bold">
                            ({fee?.batch?.title})
                          </span>
                        </td>
                        <td>₹{fee?.batch_fees}</td>
                        <td className="text-success fw-bold">
                          ₹{fee?.batch_discount || 0}
                          {hasAccess("/student/course/discount/view"
                            ) && (
                            <button
                              className="btn text-info ms-2"
                              onClick={() =>
                                setModalData({ fee: fee, default: "2" })
                              }
                            >
                              <i className="bi bi-eye text-primary"></i>
                            </button>
                          )}
                        </td>
                        <td className="text-success fw-bold">
                          ₹{fee?.total_fee}
                          {hasAccess("/student/course/discount"
                            ) && (
                            <button
                              className="btn text-info ms-2"
                              onClick={() =>
                                setModalData({ fee: fee, default: "1" })
                              }
                            >
                              <i className="bi bi-pencil-square"></i>
                            </button>
                          )}
                        </td>
                        <td className="text-success fw-bold">
                          ₹{fee?.fees_paid || 0}
                        </td>
                        <td className="text-danger fw-bold">
                          ₹{fee?.left_amount || 0}
                        </td>
                        <td className="text-secondary fw-bold">
                          ₹{fee?.reg_fee || 0}
                        </td>
                        <td className="text-warning fw-bold">
                          ₹{fee?.bus_final_fees || 0}
                          {hasAccess("/student/bus/discount"
                            ) && (
                            <button
                              className="btn text-info ms-2"
                              onClick={() =>
                                setModalData({ fee: fee, default: "3" })
                              }
                            >
                              <i className="bi bi-pencil-square"></i>
                            </button>
                          )}
                          {hasAccess("/student/bus/discount/view"
                            ) && (
                            <button
                              className="btn text-info ms-2"
                              onClick={() =>
                                setModalData({ fee: fee, default: "2" })
                              }
                            >
                              <i className="bi bi-eye text-primary"></i>
                            </button>
                          )}
                        </td>
                        <td className="text-secondary fw-bold">
                          ₹
                          {(Number(fee?.total_fee) || 0) +
                            (Number(fee?.bus_final_fees) || 0)}
                        </td>
                        <td>
                          {/* {fee?.fees_paid == 0 && ( */}
                          {hasAccess("/student/batch/transfer"
                            ) && (
                            <Link
                              to={`/batch_transfer?course_n_fees=${fee?.id}`}
                              className="btn btn-sm btn-primary"
                              onClick={() => {
                                closeModal("editUser");
                              }}
                            >
                              &#x21C6;
                            </Link>
                          )}
                          {/* )} */}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* 👇 Yahan dusre popup ka form directly conditionally dikhayenge */}
              {modalData?.default === "1" && (
                <form onSubmit={updateDicount} className="p-4 border-top">
                  <h5 className="mb-3">Course Fees Discount Change</h5>

                  <div className="alert alert-info mb-4" role="alert">
                    <strong>Important:</strong> Changing the course fee will
                    affect the student's billing and records. Please ensure the
                    information provided is accurate and authorized.
                  </div>

                  <input
                    type="hidden"
                    name="course_and_fees_id"
                    value={modalData?.fee?.id}
                  />

                  <div className="mb-3">
                    <span className="fw-semibold">Total Course Fee (₹): </span>
                    <span className="text-primary">
                      {modalData?.fee?.batch_fees || "-"}
                    </span>
                  </div>

                  <div className="mb-3">
                    <span className="fw-semibold">Final Fee (₹): </span>
                    <span className="text-primary">
                      {modalData?.fee?.total_fee || "-"}
                    </span>
                  </div>

                  <div className="mb-3">
                    <span className="fw-semibold">
                      Before Fee Discount (₹):{" "}
                    </span>
                    <span className="text-primary">
                      {modalData?.fee?.batch_discount || "-"}
                    </span>
                  </div>

                  <div className="mb-4 form-floating form-floating-outline">
                    <input
                      type="text"
                      name="final_fees"
                      className="form-control"
                      required
                      defaultValue={modalData?.fee?.total_fee || ""}
                    />
                    <label>Final Fee (₹)</label>
                    <span className="text-danger">
                      {error?.final_fees ?? ""}
                    </span>
                  </div>

                  <div className="mb-4 form-floating form-floating-outline">
                    <textarea
                      name="discount_remark"
                      className="form-control input-uppercase"
                      required
                    />
                    <label>Remark</label>
                    <span className="text-danger">
                      {error?.discount_remark ?? ""}
                    </span>
                  </div>

                  <div className="mb-4 form-floating form-floating-outline">
                    <input
                      type="file"
                      name="discount_img"
                      className="form-control"
                    />
                    <label>Upload Change Proof</label>
                    <span className="text-danger">
                      {error?.discount_img ?? ""}
                    </span>
                  </div>

                  <div className="d-flex justify-content-end gap-2">
                    <button
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={() => setModalData(null)}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary px-5"
                      disabled={loading} // Disable the button while loading
                    >
                      {loading ? (
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      ) : (
                        "Submit"
                      )}
                      {loading ? " Submitting..." : ""}
                    </button>
                  </div>
                </form>
              )}

              {modalData?.default === "2" && (
                <>
                  <div className="modal-body">
                    {/* Header */}
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h4 className="text-primary mb-0">Discount Preview</h4>
                      <button
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => setModalData(null)}
                      >
                        Close
                      </button>
                    </div>

                    {/* Discount Images */}
                    {Array.isArray(modalData?.fee?.discount_img) ? (
                      <div className="d-flex flex-wrap gap-3 mb-4">
                        {modalData.fee.discount_img.map((img, index) => (
                          <img
                            key={index}
                            src={`${imgBaseUrl}${img}`}
                            alt={`Discount Proof ${index + 1}`}
                            style={{
                              width: "120px",
                              height: "120px",
                              objectFit: "cover",
                              borderRadius: "10px",
                              border: "2px solid #ddd",
                            }}
                          />
                        ))}
                      </div>
                    ) : (
                      modalData?.fee?.discount_img && (
                        <div className="mb-4 text-center">
                          <img
                            src={`${imgBaseUrl}${modalData?.fee?.discount_img}`}
                            alt="Discount Proof"
                            style={{
                              width: "150px",
                              height: "150px",
                              objectFit: "cover",
                              borderRadius: "10px",
                              border: "2px solid #ddd",
                            }}
                          />
                        </div>
                      )
                    )}

                    {/* Discount Remarks */}
                    {modalData?.fee?.discount_remark && (
                      <div>
                        <table className="table table-bordered table-sm">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Remark</th>
                            </tr>
                          </thead>
                          <tbody>
                            {modalData.fee.discount_remark
                              .split("\n")
                              .map((remark, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td className="text-primary">{remark}</td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </>
              )}
              {modalData?.default === "3" && (
                <>
                  <div className="modal-body">
                    {/* <div className="d-flex justify-content-between"><h4 className="text-primary">Bus Discount Add</h4>
                      <button className="btn btn-sm btn-outline-primary mt-3 mb-3" onClick={() => setModalData(null)}>close</button></div> */}
                    <form onSubmit={updateDicount} className="p-4 border-top">
                      <h5 className="mb-3">Bus Discount Add</h5>

                      <div className="alert alert-info mb-4" role="alert">
                        <strong>Important:</strong> Changing the course fee will
                        affect the student's billing and records. Please ensure
                        the information provided is accurate and authorized.
                      </div>

                      <input
                        type="hidden"
                        name="course_and_fees_id"
                        value={modalData?.fee?.id}
                      />

                      <div className="mb-3">
                        <span className="fw-semibold">Total Bus Fee (₹): </span>
                        <span className="text-primary">
                          {modalData?.fee?.batch_fees || "-"}
                        </span>
                      </div>

                      <div className="mb-3">
                        <span className="fw-semibold">Bus Final Fee (₹): </span>
                        <span className="text-primary">
                          {modalData?.fee?.total_fee || "-"}
                        </span>
                      </div>

                      <div className="mb-3">
                        <span className="fw-semibold">
                          Before Fee Discount (₹):{" "}
                        </span>
                        <span className="text-primary">
                          {modalData?.fee?.batch_discount || "-"}
                        </span>
                      </div>

                      <div className="mb-4 form-floating form-floating-outline">
                        <input
                          type="text"
                          name="final_fees"
                          className="form-control"
                          required
                          defaultValue={modalData?.fee?.total_fee || ""}
                        />
                        <label>Final Fee (₹)</label>
                        <span className="text-danger">
                          {error?.final_fees ?? ""}
                        </span>
                      </div>

                      <div className="mb-4 form-floating form-floating-outline">
                        <textarea
                          name="discount_remark"
                          className="form-control input-uppercase"
                          required
                        />
                        <label>Remark</label>
                        <span className="text-danger">
                          {error?.discount_remark ?? ""}
                        </span>
                      </div>

                      <div className="mb-4 form-floating form-floating-outline">
                        <input
                          type="file"
                          name="discount_img"
                          className="form-control"
                        />
                        <label>Upload Change Proof</label>
                        <span className="text-danger">
                          {error?.discount_img ?? ""}
                        </span>
                      </div>

                      <div className="d-flex justify-content-end gap-2">
                        <button
                          type="button"
                          className="btn btn-danger btn-sm"
                          onClick={() => setModalData(null)}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary px-5"
                          disabled={loading} // Disable the button while loading
                        >
                          {loading ? (
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          ) : (
                            "Submit"
                          )}
                          {loading ? " Submitting..." : ""}
                        </button>
                      </div>
                    </form>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="addinbus"
        tabIndex={-1}
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <form onSubmit={Addstudent}>
              <div className="modal-header bg-label-primary text-white p-3">
                <h5 className="modal-title">Add Student</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                />
              </div>

              <div className="modal-body">
                <div className="row">
                  <input
                    type="hidden"
                    name="batch_id"
                    value={data?.student?.course_and_fees?.[0]?.batch?.id}
                  />
                  <input
                    type="hidden"
                    name="student_id"
                    value={data?.student?.id}
                  />

                  {/* Bus */}
                  <div className="mb-3 col-md-6 form-floating form-floating-outline">
                    <select
                      name="bus_id"
                      className="form-control"
                      value={searchBusId}
                      onChange={(e) => handleBusChange(e.target.value)}
                    >
                      <option value="">Select Bus</option>
                      {buses.map((bus) => (
                        <option key={bus.id} value={bus.id}>
                          {bus.bus_number}
                        </option>
                      ))}
                    </select>
                    <label>Select Bus</label>
                    <span className="text-danger">{error?.bus_id ?? ""}</span>
                  </div>

                  {/* Route */}
                  <div className="mb-3 col-md-6 form-floating form-floating-outline">
                    <select
                      name="route_id"
                      className="form-control"
                      value={selectedRouteId}
                      onChange={(e) => handleRouteChange(e.target.value)}
                    >
                      <option value="">Select Route</option>
                      {Array.isArray(routes) && routes.length > 0 ? (
                        routes.map((route) => (
                          <option key={route.id} value={route.id}>
                            {route.route_name}
                          </option>
                        ))
                      ) : (
                        <option disabled>No routes found</option>
                      )}
                    </select>
                    <label>Select Route</label>
                    <span className="text-danger">{error?.route_id ?? ""}</span>
                  </div>

                  {/* Bus Fees */}
                  <div className="mb-3 col-md-6 form-floating form-floating-outline">
                    <input
                      type="text"
                      name="bus_fees"
                      className="form-control"
                      value={busFees}
                      readOnly
                    />
                    <label>Bus Fees</label>
                    <span className="text-danger">{error?.bus_fees ?? ""}</span>
                  </div>

                  {/* Final Fees */}
                  <div className="mb-3 col-md-6 form-floating form-floating-outline">
                    <input
                      type="number"
                      name="bus_final_fees"
                      className="form-control"
                      value={busFinalFees}
                      onChange={(e) => setBusFinalFees(e.target.value)}
                    />
                    <label>Final Fees</label>
                    <span className="text-danger">
                      {error?.bus_final_fees ?? ""}
                    </span>
                  </div>

                  {/* Discount */}
                  <div className="mb-3 col-md-6 form-floating form-floating-outline">
                    <input
                      type="text"
                      name="bus_discount"
                      className="form-control"
                      value={busDiscount}
                      readOnly
                    />
                    <label>Discount</label>
                    <span className="text-danger">
                      {error?.bus_discount ?? ""}
                    </span>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary px-5"
                  disabled={loading} // Disable the button while loading
                >
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    "Submit"
                  )}
                  {loading ? " Submitting..." : ""}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="discountModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="d-flex justify-content-between">
                <h4 className="text-primary">Discount Preview</h4>
                <button
                  className="btn btn-sm btn-outline-primary mt-3 mb-3"
                  data-bs-dismiss="modal"
                >
                  close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseNFeeTab;
